module.exports = __webpack_public_path__ + "img/IMG_4926.ebf9889a.jpg";